import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __ } from "@jti/fe-common";
import { Txt } from "@jti/ui";
import styles from "./Order.module.scss";
const OrderLabel = ({ title, children, className }) => (_jsxs(Txt, { className: styles.orderLabel, children: [_jsx("span", { className: styles.orderText, children: __(title) }), _jsx("span", { className: className, dir: "ltr", children: children })] }));
export default OrderLabel;
//# sourceMappingURL=OrderLabel.js.map